import { ActivityEditorController } from '../activity-editor.controller';
import { LlmDefinition } from '@go-modules/interfaces/llm-definition';

export interface Bindings {
	activityEditorController: ActivityEditorController;
	llmDefinitions: LlmDefinition[];
	activity: any;
	onPreview: () => void;
	onEdit: () => void;
	onRemove: () => void;
}

export class AiMarkerSetPanelController implements Bindings {

	// Bindings
	public activityEditorController: ActivityEditorController;
	public llmDefinitions: LlmDefinition[];
	public activity: any;
	public canPreview: boolean;
	public onPreview: () => void;
	public onEdit: () => void;
	public onRemove: () => void;

	public markers;

	/* @ngInject */
	constructor (
		private $scope: ng.IScope
	) {}

	public $onChanges (changes: ng.IOnChangesObject): void {
		if (changes.llmDefinitions) {
			this.markers = this.llmDefinitions.map((definition) => {
				return definition.tags[0];
			});
			this.safeDigest();
		}
	}

	private safeDigest () {
		const phase = this.$scope.$root.$$phase || this.$scope.$$phase;
		if (!phase) {
			this.$scope.$digest();
		}
	}
}
